import api from '../../../services/api';

/**
 * Endpoints do M9 com o nome do domínio.
 *
 * ⚠️ Repasse fino para `services/api.js`, onde os endpoints do projeto moram —
 * nenhuma regra, nenhum transporte próprio. Criar a OS de CONTAGEM continua
 * sendo `api.createWarehouseServiceOrder` (M5) com `count_blocks` no corpo:
 * não existe segundo jeito de criar OS.
 */
export function GetOccupancy() {
    return api.getInventoryOccupancy();
}

export function GetAging(params = {}) {
    return api.getInventoryAging(params);
}

export function GetSla(params = {}) {
    return api.getInventorySla(params);
}

/** A PROVA de que os outros painéis podem ser acreditados: saldo × trilha. */
export function GetReconciliation(params = {}) {
    return api.getInventoryReconciliation(params);
}

export function GetCountExpectation(serviceOrderId, itemId) {
    return api.getCountExpectation(serviceOrderId, itemId);
}

export function CountServiceOrderItem(serviceOrderId, itemId, body) {
    return api.countServiceOrderItem(serviceOrderId, itemId, body);
}
